import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { KnowledgeBaseUpload } from "@/components/KnowledgeBaseUpload";
import { useToast } from "@/hooks/use-toast";

const CallForKnowledgeBountyDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const [selectedDomain, setSelectedDomain] = useState<string>("");
  const [isBounty, setIsBounty] = useState<boolean>(false);
  const [creator, setCreator] = useState<string>("");

  useEffect(() => {
    const state = location.state as any;
    if (state) {
      setSelectedDomain(state.selectedDomain || "");
      setIsBounty(state.isBounty === "yes" || state.isBounty === true);
      setCreator(state.creator || "");
    }
  }, [location.state]);

  const handleSuccess = (knowledgeBaseId: string) => {
    toast({
      title: "Knowledge Base Created!",
      description: "Your knowledge has been successfully uploaded and is now in your personal collection."
    });
    navigate("/myspai-profile");
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="flex flex-col items-center p-4 pb-12">
      <div className="mt-8 mb-6">
        <img 
          src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" 
          alt="iSPAI Logo" 
          className="h-16 cursor-pointer"
          onClick={() => navigate("/engage")}
        />
      </div>

      <h1 className="text-3xl font-bold text-black mb-8 text-center">
        Upload Knowledge Base
      </h1>

      <div className="w-full max-w-4xl">
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-bold mb-4">Selected Configuration</h2>
            <div className="space-y-2 text-gray-700 mb-6">
              <p>Type: {isBounty ? 'Bounty' : 'Standard Contribution'}</p>
              {creator && <p>Creator: {creator}</p>}
            </div>

            <KnowledgeBaseUpload
              domainId={selectedDomain}
              isBounty={isBounty}
              onSuccess={handleSuccess}
            />
          </CardContent>
        </Card>

        <div className="flex justify-between mt-8">
          <Button 
            variant="outline"
            onClick={() => navigate("/call-for-knowledge/curator")}
          >
            Back
          </Button>
        </div>
      </div>
      </div>
    </div>
  );
};

export default CallForKnowledgeBountyDetails;
